module.exports = __webpack_public_path__ + "img/app_3.6ec69cfd.jpg";